import React, { FC } from 'react';

import { TotalPriceBlockProps } from './types';
import { Amount, Discount, NextDate } from './components';

import styles from './index.module.scss';

const TotalPriceBlock: FC<TotalPriceBlockProps> = ({
  currentPeriod,
  selectedPriceItemPeriodId,
  selectedPriceItemPeriodTitle,
  periodPayFrequencyMonth,
  withPricePlanAlias = false,
}) => (
  <div className={styles.container}>
    <div className={styles.mainBlock}>
      <Amount
        selectedPriceItemPeriodId={selectedPriceItemPeriodId}
        currentPeriodId={currentPeriod?.id}
        withPricePlanAlias={withPricePlanAlias}
        periodPayFrequencyMonth={periodPayFrequencyMonth}
      />

      {currentPeriod?.id === selectedPriceItemPeriodId && <Discount />}
    </div>

    <NextDate selectedPriceItemPeriodTitle={selectedPriceItemPeriodTitle} />
  </div>
);

export default React.memo(TotalPriceBlock);
